import React from 'react';
import { LayersIcon, ActivityIcon, GitBranchIcon, BookOpenIcon, GiftIcon, ClipboardCheckIcon } from 'lucide-react';
import { METHOD_TEXT } from '../data/constants';
const POINTS = [{
  icon: LayersIcon,
  title: 'Un atlas visuel prêt à consulter',
  body: 'Fiches atlas par élément, symptômes par organe et tableaux de référence : ouvrez le système sur la tablette au champ ou imprimez-le, au lieu de chercher dans plusieurs sources.'
}, {
  icon: ActivityIcon,
  title: 'Une méthode pour chaque symptôme',
  body: `${METHOD_TEXT} : toujours le même ordre, pour ne sauter aucune étape.`
}, {
  icon: GitBranchIcon,
  title: 'Des arbres de décision',
  body: 'Feuilles âgées ou jeunes feuilles, chlorose ou nécrose, sol ou plante : chaque situation fréquente a son chemin de vérification, du plus simple au plus poussé.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Des protocoles et fiches de terrain',
  body: 'Inspection de parcelle, prélèvements sol et foliaires, suivi des interventions, checklists et modèles de rapport : prêts à l’emploi.'
}, {
  icon: BookOpenIcon,
  title: '6 modules complémentaires',
  body: 'Fondamentaux, carences et symptômes visuels, sol et pH, diagnostic et analyses, nutrition par culture, plan d’action et suivi.'
}, {
  icon: GiftIcon,
  title: '5 bonus pratiques',
  body: 'Analyses de sol, fiches de terrain imprimables, carences vs maladies, calculs de fertilisation, cahier de 40 cas pratiques.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-115" data-mp="2srmd61akqxme">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-116" data-mp="2nr725gdrm27l">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-117" data-mp="2ntta3h4kijqc">
          CE N’EST PAS UN SIMPLE EBOOK DE PLUS SUR LA NUTRITION DES PLANTES
        </h2>
        <p className="mt-1 text-center font-display text-sm font-bold uppercase leading-tight text-tech-light sm:text-xl" data-id="element-118" data-mp="1cdcot76c18vk">
          C’EST UN SYSTÈME PROFESSIONNEL COMPLET POUR DIAGNOSTIQUER ET DÉCIDER AVEC MÉTHODE.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-119" data-mp="19q29ni5u5meu">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3" data-id="element-120" data-mp="zt5zz947au8p">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech-light" aria-hidden="true" data-id="element-121" data-mp="r1xcitjoozp0" />
                <div data-id="element-122" data-mp="vsdqcerf2nbw">
                  <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-123" data-mp="vsm408vd5wo5">{point.title}</h3>
                  <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-124" data-mp="h494x30zbxpf">{point.body}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-white sm:text-lg" data-id="element-125" data-mp="82rrxtivcc4y">
          Moins d’apports décidés au hasard. <span className="text-tech-light" data-id="element-126" data-mp="c3bp2x3fzfr3">Plus de méthode, parcelle après parcelle.</span>
        </p>
      </div>
    </section>;
}